var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBar'),_c('DocumentMenu'),_c('DocumentFilter'),_c('DocumentList'),_c('DocumentLink'),_c('DocumentDelete'),_c('DocumentVisitors'),_c('DocumentNonVisitors'),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }